import { forwardRef, type Ref, type SVGProps } from "react";
const IconShoppingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M18 7V6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2.954a1 1 0 0 1 .999 1.045L29.5 18l.434 6.938A1 1 0 0 1 28.936 26H18.863l-.357-5 .413-5.786A3 3 0 0 0 15.926 12h-1.698l-.18-3.955A1 1 0 0 1 15.047 7zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4z"
        fill="currentColor"
      />
      <path
        d="m16.51 21.142.414 5.787A1 1 0 0 1 15.926 28H3.074a1 1 0 0 1-.997-1.071l.413-5.787q.01-.142 0-.284l-.413-5.787A1 1 0 0 1 3.074 14H6v-1a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v1h2.926a1 1 0 0 1 .998 1.071l-.413 5.787q-.01.142 0 .284zM11 14v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1z"
        fill="currentColor"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconShoppingFilledSVG);
ForwardRef.displayName = "IconShoppingFilled";
export { ForwardRef as IconShoppingFilled };
